import { mdiAlertCircleOutline, mdiAlertOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { Trans, useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Center } from '@/components/ui/center'
import { Link } from '@/components/ui/link'
import { HStack, VStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { toggleQuotasDrawer } from '@/store/gigiChat/Quotas'

const ProhibitedUpload = ({ isFullHeight, isVpn }: { isFullHeight: boolean; isVpn: boolean }) => {
    const { t } = useTranslation()

    const height = isFullHeight ? '100%' : '96px'

    const overQuota = () => {
        return (
            <VStack alignItems="flex-start">
                <Box textAlign="left">{t('documents.overQuotaProhibited')}</Box>
                <Box>
                    <Trans
                        i18nKey={'documents.overQuotaProhibited2'}
                        components={[<Link onClick={toggleQuotasDrawer} textDecoration="underline" />]}
                    />
                </Box>
            </VStack>
        )
    }

    return (
        <Box
            backgroundColor={isVpn ? 'var(--chakra-colors-yellow-50)' : 'var(--chakra-colors-red-100)'}
            height={height}
            width="99%"
            mt="16px"
        >
            <Center h="100%">
                <HStack>
                    <Box width="50px">
                        {isVpn ? (
                            <Icon
                                path={mdiAlertOutline}
                                size="24px"
                                color="var(--chakra-colors-yellow-500)"
                                style={{
                                    marginTop: '7px',
                                    marginLeft: '16px',
                                }}
                            />
                        ) : (
                            <Icon
                                path={mdiAlertCircleOutline}
                                size="18px"
                                color="var(--chakra-colors-red-500)"
                                style={{
                                    marginLeft: 'auto',
                                }}
                            />
                        )}
                    </Box>
                    <Text
                        fontSize="14px"
                        letterSpacing="0.25px"
                        alignContent="center"
                        color="var(--chakra-colors-dark-700)"
                        as="div"
                        marginTop="16px"
                        marginBottom="16px"
                        marginRight="16px"
                    >
                        {isVpn ? <Box textAlign="left">{t('documents.vpnProhibited')} </Box> : overQuota()}
                    </Text>
                </HStack>
            </Center>
        </Box>
    )
}

export default ProhibitedUpload
